export * from './purchase-of-alarm-system.component';
export * from './purchase-of-alarm-system-document-capture.component';
export * from './purchase-of-alarm-system.module';